import React, { useState, useEffect } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { handlePostRequest } from "../../services/PostTemplate";

function DepositSubDetailForm({ liquidationStatus, transHeadId }) {
    const [loading, setloading] = useState(false);

    const formik = useFormik({
        initialValues: {
            liquidationReason: "",
        },
        validate: (data) => {
            let errors = {};

            if (!data.liquidationReason) {
                errors.liquidationReason = "This field is required.";
            }

            return errors;
        },
        onSubmit: async (data) => {
            setloading(true);
            data["liquidationStatus"] = liquidationStatus;
            data["transHeadIds"] = transHeadId;
            await handlePostRequest(data, "zbizgateway/fin/collection/updateLiquidation");
            setloading(false);
            formik.resetForm();
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <div className="card Card__Round">
                <div className="Form__Header">
                    <h1>{liquidationStatus === "A" ? "Approve" : "Reject"} Liquidation</h1>
                </div>
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-12">
                            <div className="p-field">
                                <label htmlFor="liquidationReason" className={classNames({ "p-error": isFormFieldValid("liquidationReason") }, "Label__Text")}>
                                    Reason<span className="Label__Required">*</span>
                                </label>

                                <InputTextarea
                                    placeholder="Add Reason......."
                                    id="liquidationReason"
                                    name="liquidationReason"
                                    value={formik.values.liquidationReason}
                                    rows={5}
                                    cols={10}
                                    onChange={formik.handleChange}
                                    className={classNames({ "p-invalid": isFormFieldValid("liquidationReason") }, "TextArea__Round")}
                                />

                                {getFormErrorMessage("liquidationReason")}
                            </div>
                        </div>
                    </div>
                    <div className="Down__Btn">
                        <Button disabled={loading} type="submit" label="Ok" className="Btn__Dark" />
                    </div>
                </form>
            </div>
        </>
    );
}

export default DepositSubDetailForm;
